





























// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';
import Endpoints from '@/constants/endpoints';

// Views
import InfoView from '@/shared/views/info.view.vue';

// Services
import { PurchaseService } from '@/manager/purchase/purchase.service';

@Component({
    components: {
        InfoView,
    },
    computed: {
        ...mapGetters({
            getPurchase: 'getPurchase',
        }),
    },
})
export default class DownloadView extends Vue {
    @Prop() private purchaseId!: string;
    @Prop() private companionId!: string;


    private assets = Assets;
    private endpoints = Endpoints;
    private getPurchase !: any;
    private getCompanion !: any;
    private infoLiterals =  {
        title: '¡Inscripción completada!',
        subtitle: 'Enhorabuena, has finalizado con éxito el proceso de inscripción. ' +
            'Descarga los siguientes documentos ahora o vuelve más tarde a través del enlace que recibirás en tu cuenta de correo:',
    };


    get purchase() {
        return this.getPurchase(this.purchaseId);
    }

    get isPurchase() {
        return this.purchaseId !== undefined;
    }

    get backgroundImage() {
        return {
            'background-image': `url("${this.assets.circleBlueGreen}")`,
            'background-repeat': 'no-repeat',
            'background-size': '400px 400px',
        };
    }

    get pruchaseUrl() {
        return PurchaseService.purchaseUrl(this.purchase);
    }

    get hasBill() {
        return this.purchase.bill !== null;
    }

    get billUrl() {
        return PurchaseService.billUrl(this.purchase);
    }


}
